import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useTranslation } from "react-i18next";

export default function PrivacyPage() {
  const { t } = useTranslation(["pages"]);

  const sections = t("pages:privacy.sections", { returnObjects: true }) as {
    title: string;
    content: string;
  }[];

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-slate-900">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/4d352d66822b2c07e37690a06225828c.jpg"
            alt="Privacy Policy"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <p className="text-emerald-400 text-sm font-semibold uppercase tracking-widest mb-4">
            {t("pages:privacy.hero.subtitle")}
          </p>
          <h1
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {t("pages:privacy.hero.title")}
          </h1>
          <p className="text-slate-400 text-sm">
            {t("pages:privacy.hero.updated")}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-10">
            {sections.map((section, i) => (
              <div key={i} className="border-b border-slate-100 pb-10 last:border-0">
                <h2
                  className="text-xl font-bold text-slate-900 mb-4"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {section.title}
                </h2>
                <p className="text-slate-600 leading-relaxed text-base">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
